"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.connect = exports.firebase_app = void 0;
var app_1 = require("firebase/app");
function connect(env) {
    if (env === void 0) { env = 'PROD'; }
    switch (env) {
        case "DEV":
            exports.firebase_app = (0, app_1.initializeApp)({
                apiKey: "AIzaSyBsEthvwyyBqUIcykIIQpXusrgQ6Je16RI",
                authDomain: "greenchart-dev.firebaseapp.com",
                databaseURL: "https://greenchart-dev-default-rtdb.firebaseio.com",
                projectId: "greenchart-dev",
                storageBucket: "greenchart-dev.appspot.com",
                messagingSenderId: "506245531367",
                appId: "1:506245531367:web:52d1097c63030820b40442",
                measurementId: "G-2GYK8TEYFX"
            });
            break;
        case "PROD":
            exports.firebase_app = (0, app_1.initializeApp)({
                apiKey: "AIzaSyD33m4VSGtjXLketIRCi_68hEngNgMe2DM",
                authDomain: "greenchart-93a2a.firebaseapp.com",
                databaseURL: "https://greenchart-93a2a.firebaseio.com",
                projectId: "greenchart-93a2a",
                storageBucket: "greenchart-93a2a.appspot.com",
                messagingSenderId: "86344372816",
                appId: "1:86344372816:web:2bfdc62c0d06f88c86f755",
                measurementId: "G-WM1QNRNRQC"
            });
            break;
        default:
            throw "Need environment: DEV | PROD";
    }
    return exports.firebase_app;
}
exports.connect = connect;
